import type { Round } from "../api/types";
import { ATTACK_COLOR, DEFENSE_COLOR, OUTCOME_LABEL } from "../lib/view";

interface Props {
  rounds: Round[];
  current: number;
  onSelect: (round: number) => void;
}

/** One button per round, coloured by which side won it. */
export function RoundStrip({ rounds, current, onSelect }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-1 border-b border-white/10 px-3 py-2">
      {rounds.map((round) => {
        const attackersWon = !!round.winner && round.winner === round.attackers;
        const color = attackersWon ? ATTACK_COLOR : DEFENSE_COLOR;
        const selected = round.number === current;
        return (
          <button
            key={round.number}
            onClick={() => onSelect(round.number)}
            title={`Round ${round.number} — ${OUTCOME_LABEL[round.outcome] ?? round.outcome}`}
            className={`h-7 w-7 rounded text-xs font-medium transition ${
              selected ? "ring-2 ring-white" : "hover:brightness-125"
            }`}
            style={{
              background: round.winner ? `${color}33` : "rgba(255,255,255,0.06)",
              borderBottom: `2px solid ${round.winner ? color : "transparent"}`,
            }}
          >
            {round.number}
          </button>
        );
      })}
    </div>
  );
}
